/**
 * Controles de paginación. Se oculta solo si hay una sola página — no tiene
 * sentido mostrar "Mostrando 1-4 de 4" con los botones deshabilitados.
 */
interface Props {
  pagina: number;
  totalPaginas: number;
  desde: number;
  hasta: number;
  total: number;
  onIrAPagina: (pagina: number) => void;
}

/** Ventana de números de página alrededor de la actual, para no imprimir 40
 *  botones cuando hay muchas páginas. */
function paginasVisibles(pagina: number, totalPaginas: number): number[] {
  const ventana = 2;
  const inicio = Math.max(1, Math.min(pagina - ventana, totalPaginas - ventana * 2));
  const fin = Math.min(totalPaginas, Math.max(pagina + ventana, ventana * 2 + 1));
  const paginas: number[] = [];
  for (let p = inicio; p <= fin; p++) paginas.push(p);
  return paginas;
}

export function Paginador({ pagina, totalPaginas, desde, hasta, total, onIrAPagina }: Props) {
  if (totalPaginas <= 1) return null;

  return (
    <div className="paginador">
      <span className="paginador-rango">
        Mostrando <b>{desde}</b>–<b>{hasta}</b> de <b>{total}</b>
      </span>

      <div className="paginador-controles">
        <button
          className="btn-ghost"
          disabled={pagina === 1}
          onClick={() => onIrAPagina(pagina - 1)}
        >
          ‹ Anterior
        </button>

        {paginasVisibles(pagina, totalPaginas).map((p) => (
          <button
            key={p}
            className={p === pagina ? "pagina-actual" : "btn-ghost"}
            onClick={() => onIrAPagina(p)}
          >
            {p}
          </button>
        ))}

        <button
          className="btn-ghost"
          disabled={pagina === totalPaginas}
          onClick={() => onIrAPagina(pagina + 1)}
        >
          Siguiente ›
        </button>
      </div>
    </div>
  );
}
